module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Position-c5e3f6b657c1d5944467b35d3de644b9.svg";